"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_report(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "99c0ff7e-9db4-4d1b-b201-48bb24a939f2",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 112 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "bill-or-report"), /*#__PURE__*/React.createElement("g", {
    id: "822429d7-0303-4520-88fe-7b152fd0584f",
    "data-name": "Bill_or_Report_ic"
  }, /*#__PURE__*/React.createElement("line", {
    id: "3525a9e0-2315-4d7d-8028-c9074aff38be",
    "data-name": "<Pfad>",
    x1: 84,
    y1: 68,
    x2: 52,
    y2: 68,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "28f082cf-2892-4b8a-9133-937bd6e709ce",
    "data-name": "<Pfad>",
    x1: 36,
    y1: 68,
    x2: 28,
    y2: 68,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "ea1cc57b-e080-4085-bf7f-b7ace87fcf8f",
    "data-name": "<Pfad>",
    x1: 84,
    y1: 92,
    x2: 52,
    y2: 92,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "04605d73-3229-45a8-b869-af8053817214",
    "data-name": "<Pfad>",
    x1: 36,
    y1: 92,
    x2: 28,
    y2: 92,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "fc411bc8-47dc-4d81-83d7-4295a6f15746",
    "data-name": "<Pfad>",
    x1: 84,
    y1: 116,
    x2: 52,
    y2: 116,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "e41f815f-9673-4ff5-962b-60311d9393c8",
    "data-name": "<Pfad>",
    x1: 36,
    y1: 116,
    x2: 28,
    y2: 116,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "66aa36c8-8388-4e49-8e86-7e410168948c",
    "data-name": "Document_ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,52,116,20H56A12,12,0,0,0,44,32V160a12,12,0,0,0,12,12h80a12,12,0,0,0,12-12V52Z",
    transform: "translate(-40 -16)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "76 4.23 76 36 108 36",
    strokeLinejoin: "round"
  }))));
}

var _default = ic_report;
exports.default = _default;